import React from "react";
import { HalfPicture } from "../components/BackgroundPicture";
import { RepLeaderBoard, DurationLeaderboard } from "../components/Tables";
import { TextSection } from "../components/TextSection";
import Grid from "@material-ui/core/Grid";

export const Leaderboard = () => {
  return (
    <>
      <HalfPicture
        url="url-5"
        photographer="Foto: Roland Richter/NTNUI"
        titleText="Leaderboard"
      />
      <div className="page">

        <TextSection
          title="Leaderboard"
          text={"Every semester our group dedicates some weeks to testing our performance; max reps and max holds on different exercises. These are the all-time best records of our members."}
        />

        <Grid container spacing={4}>
                    
          <Grid item xs={12} md={6}>
            <TextSection title="Repetition-based"/>
            <RepLeaderBoard />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextSection title="Duration-based"/>
            <DurationLeaderboard />
          </Grid>

        </Grid>
      </div>
    </>
  );
};

export default Leaderboard;
